import React, { useEffect, useState } from "react";
import styled from 'styled-components'
import { Col, Row } from 'react-bootstrap';

import HelpForm from "../../components/HelpForm/HelpForm";

const Help = () => {

    return (
        <Container>
            <Row>
                <Col xs={12}>
                    <HelpForm />
                </Col>
            </Row>
            
        </Container>
    );
}

const Container = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
    float:left;
    background: #fff;
    @media only screen and (max-width: 2400px) {
        width: 66%;
        height: 100%;
        position: relative;
        float:none;
        margin: 0 auto;
    };
    @media only screen and (max-width: 800px) {
        width: 95% !important;
        height: 100%;
        position: relative;
        float:none;
        margin: 0 auto;
        background: #fff;
    };
`

export default Help;